import apiData from './../data/api.json';

const sendData = (data, page) => {
  const url = apiData['tracker'];
  const time = String(new Date(data.time_zone.current_time)).slice(0,24);
  fetch(`${url}?ip=${data.ip}&country_name=${data.country_name}&district=${data.district}&city=${data.city}&time=${time}&page=${page}`)
    .then((response) => (response.json()))
    .then((result)=> result);
};

export function trackApi(page) {
  if (apiData['track']) {
    fetch(apiData['geolocation'])
      .then((response) => (response.json()))
      .then((result) => {
        if (result) {
          sendData(result, page);
        }
      });
  }
}
